import { A as v } from "./Logger-b1967205.mjs";
var n = /* @__PURE__ */ ((o) => (o.PERMANENT = "localstorage", o.TEMPORARY = "sessionstorage", o.COOKIE = "cookie", o))(n || {}), E = Object.defineProperty, O = (o, e, t) => e in o ? E(o, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : o[e] = t, m = (o, e, t) => (O(o, typeof e != "symbol" ? e + "" : e, t), t);
let d = class {
  constructor(e) {
    m(this, "_options"), this._options = e;
  }
  store(e, t) {
    document.cookie = `${e}=${t}`;
  }
  retrieve(e) {
    var t;
    const r = document.cookie;
    return e && r.includes(`${e}=`) ? (t = r.split(`${e}=`)[1]) == null ? void 0 : t.split(";")[0] : "";
  }
  remove(e) {
    const t = document.cookie;
    e && t.includes(`${e}=`) && (document.cookie = `${e}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;`);
  }
  clearStorage() {
  }
};
const c = d;
function u(o) {
  return btoa(encodeURIComponent(o));
}
function g(o) {
  return decodeURIComponent(window == null ? void 0 : window.atob(o));
}
function s(o) {
  return typeof o == "string" ? o : JSON.stringify(o);
}
function p(o) {
  try {
    return JSON.parse(`${o}`);
  } catch {
    return o;
  }
}
var f = Object.defineProperty, y = (o, e, t) => e in o ? f(o, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : o[e] = t, S = (o, e, t) => (y(o, typeof e != "symbol" ? e + "" : e, t), t);
class b {
  constructor(e) {
    S(this, "options"), this.options = e;
  }
  store(e, t) {
    var r;
    const i = (r = this.options) != null && r.encryption ? u(s(t)) : s(t);
    localStorage.setItem(e, i);
  }
  retrieve(e) {
    var t;
    const r = localStorage.getItem(e);
    return r && p((t = this.options) != null && t.encryption ? g(r) : r);
  }
  remove(e) {
    localStorage.removeItem(e);
  }
  clearStorage() {
    localStorage.clear();
  }
}
const a = b;
var R = Object.defineProperty, $ = (o, e, t) => e in o ? R(o, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : o[e] = t, w = (o, e, t) => ($(o, typeof e != "symbol" ? e + "" : e, t), t);
let P = class {
  constructor(e) {
    w(this, "options"), this.options = e;
  }
  store(e, t) {
    var r;
    const i = (r = this.options) != null && r.encryption ? u(s(t)) : s(t);
    sessionStorage.setItem(e, i);
  }
  retrieve(e) {
    var t;
    const r = sessionStorage.getItem(e);
    return r && p((t = this.options) != null && t.encryption ? g(r) : r);
  }
  remove(e) {
    sessionStorage.removeItem(e);
  }
  clearStorage() {
    sessionStorage.clear();
  }
};
const l = P, T = function(o, e) {
  let t = {};
  const r = v.getInstance();
  if (o)
    if (o.storageService)
      ({ storageService: t } = o), r.log("Storage Service already loaded, using existing version");
    else
      return o.storageService = t, e(t);
  return t;
}(
  typeof window == "object" && window || typeof globalThis == "object" && globalThis || void 0,
  function(o) {
    const e = {
      [n.PERMANENT]: { encryption: !0 },
      [n.TEMPORARY]: { encryption: !0 },
      [n.COOKIE]: {}
    }, t = {
      [n.PERMANENT]: new a({
        ...e[n.PERMANENT]
      }),
      [n.TEMPORARY]: new l({
        ...e[n.TEMPORARY]
      }),
      [n.COOKIE]: new c({
        ...e[n.COOKIE]
      })
    };
    return o.getStorage = (r = n.PERMANENT) => t[r], o.getLocalStorage = () => t[n.PERMANENT], o.getSessionStorage = () => t[n.TEMPORARY], o.getCookieStorage = () => t[n.COOKIE], o.setConfig = (r) => {
      for (const i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (i === n.PERMANENT && (t[i] = new a({
          ...r[i]
        })), i === n.TEMPORARY && (t[i] = new l({
          ...r[i]
        })), i === n.COOKIE && (t[i] = new c({
          ...r[i]
        })));
    }, o;
  }
), A = T;
export {
  A as l
};
//# sourceMappingURL=Storage-856059e3.mjs.map
